<template>
  <div class="chart">
    <div class="data mt-2">
      <div :class="lang === 'ar' ? 'regular-ar' : 'regular-en'">{{ $t('profile.use')}}</div>
      <div :class="lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">{{ data.percent }}%</div>
    </div>
    <div :class="[lang === 'ar' ? 'bold-ar' : 'bold-en', 'type']">
      {{ data.type }}
    </div>
    <canvas :id="data.id"></canvas>
  </div>
</template>
<script>
import Chart from 'chart.js'
export default {
  props: {
    data: Object
  },
  data () {
    return {
      lang: this.$lang,
      options: {},
      character: null
    }
  },
  created () {
    // console.log(this.data)
  },
  mounted () {
    Chart.defaults.global.tooltips.enabled = false
    this.character = new Chart(document.getElementById(this.data.id), {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: [this.data.percent, 100 - this.data.percent],
            backgroundColor: [
              'rgba(255,203,5, 1)',
              'rgba(255,203,5,.4)'
            ],
            borderWidth: 0
          }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 70, // This sets the percentage of the chart that is hollow
        rotation: 8.52, // This rotates the chart so that the first dataset starts at the top
        circumference: 5, // This sets the total angle covered by the chart
        animation: {
          animateRotate: true,
          duration: 1000
        },
        plugins: {
          tooltips: {
            enabled: false
          }
        }
      }
    })
  }
}
</script>
<style>
.chart {
  height: 140px;
  width: 140px;
  margin: 0px auto 0 auto;
  position: relative;
}
.data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
}
.data > div:last-child {
  font-size: 20px;
}
.type {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 5px;
  font-size: 17px
}
</style>
